import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@shared/services/loading.service';
import { PopFeatureFlag } from '@shared/services/models/pop-feature-flag.model';
import { PopSettingService } from '@shared/services/pop-settings.service';

@Component({
  selector: 'pop-settings-override',
  templateUrl: './settings-override.component.html',
  styleUrls: ['./settings-override.component.less']
})
export class SettingsOverrideComponent implements OnInit {
  public flags: PopFeatureFlag[];

  public constructor(private settingsService: PopSettingService, private loadingService: LoadingService) {}

  public async ngOnInit() {
    this.flags = await this.loadingService.run(async () => await this.settingsService.getFeatureFlags());
  }

  public setFlag(flag: PopFeatureFlag) {}
}
